"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ProductChooser = _interopRequireDefault(require("./ProductChooser"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _axios = _interopRequireDefault(require("axios"));

var _excluded = ["initialSelectedProducts", "setSelectedProducts", "showAppendAllButton", "axiosInstance"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ProductChooserDialog = function ProductChooserDialog(props) {
  var initialSelectedProducts = props.initialSelectedProducts,
      setSelectedProducts = props.setSelectedProducts,
      showAppendAllButton = props.showAppendAllButton,
      _props$axiosInstance = props.axiosInstance,
      axiosInstance = _props$axiosInstance === void 0 ? _axios.default.create() : _props$axiosInstance,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react.default.createElement(_Dialog.default, _extends({}, rest, {
    maxWidth: false,
    PaperProps: {
      style: {
        width: "95vw",
        height: "95vh"
      }
    },
    keepMounted: true
  }), /*#__PURE__*/_react.default.createElement(_DialogTitle.default, null, "Products Chooser"), /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, /*#__PURE__*/_react.default.createElement(_ProductChooser.default, props)));
};

var _default = ProductChooserDialog;
exports.default = _default;